import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const allProduitType = createAsyncThunk("produit/allProduitType", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/allProduitType", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const produit = await response.json();
  return produit;
});

export const produitChangerEtat = createAsyncThunk("produit/changerEtat", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/changerEtat/" + id, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const status = await response.status;
  return status;
});

export const saveImageProduit = createAsyncThunk("produit/saveImageProduit", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/saveImageProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const produit = await response.json();
  return produit;
});
export const fetchProduit = createAsyncThunk("produit/fetchProduit", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/allProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const produit = await response.json();
  return produit;
});

export const fetchProduitAfc = createAsyncThunk("produit/fetchProduitAfc", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/allProduitAfc", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const produit = await response.json();
  return produit;
});

export const allProduitApp = createAsyncThunk("produit/allProduitApp", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/allProduitApp", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const produit = await response.json();
  return produit;
});

export const produitAdded = createAsyncThunk("produit/addProduit", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/addProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const produit = await response.json();
  return produit;
});

export const produitAddedParent = createAsyncThunk("produit/addProduitParent", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/addProduitParent", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const produit = await response.json();
  return produit;
});

export const updateProduit = createAsyncThunk("produit/updateProduit", async (data) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/updateProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(data),
  });

  const produit = await response.json();
  return produit;
});

export const fetchProduitFour = createAsyncThunk("produit/fetchProduitFour", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/fetchProduitFour", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action),

  });
  const produit = await response.json();
  return produit;
});
export const getProduitFour = createAsyncThunk("produit/getProduitFour", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "produit/getProduitFour", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const produit = await response.json();
  return produit;
});
export const produitGetById = createAsyncThunk("produit/produitGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "produit/getProduit", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const produit = await response.json();
  return produit;
});
const produitReduce = createSlice({
  name: "produit",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    produitDeleted(state, action) {
      const { id } = action.payload;
      return new Promise((resolve, reject) => {
        fetch(Configuration.BACK_BASEURL + "produit/deleteProduit/" + id, {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
          },
        })
          .then(response => {
            console.log('Produit supprimée avec succès');
            resolve(); // Résoudre la promesse si la suppression réussit
          })
          .catch(error => {
            console.error('Erreur lors de la suppression de l\'produit:', error);
            reject(error); // Rejeter la promesse en cas d'erreur
          });
      });
    },


  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProduit.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchProduit.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchProduit.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(produitGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(produitGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(produitGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },

});

export const { produitDeleted } = produitReduce.actions;

export default produitReduce.reducer;
